import { OverridableStringUnion } from '@mui/types';
import { PreDefinedTag, ReportStatus, ScheduledEventStatus } from './store/types';
import { ChipPropsColorOverrides } from '@mui/material';

// Used in the reporting page
export const REPORTING_LIBRARY_TAB_KEY = 'library';
export const REPORTING_GENERATION_TAB_KEY = 'generation';
export const REPORTING_SCHEDULER_KEY = 'scheduler';
export const REPORTING_PARAMETERS_KEY = 'report-parameters';

// Used in the reporting/batch page
export const REPORTING_DETAILS_KEY = 'details';
export const REPORTING_EMAIL_TEMPLATE_KEY = 'email';
export const REPORTING_REPORTS_KEY = 'reports';
export const REPORTING_LOGS_KEY = 'logs';
export const REPORTING_MEMBERS_KEY = 'members';
export const REPORTING_MEMBER_LOGS_KEY = 'member_logs';

export const REPORTING_CURRENT_TAB_KEY = 'tab';

export const MAX_TAGS = 6;
export const PRE_DEFINED_TAGS: PreDefinedTag[] = [
  { tag: 'Variable', example: ' ' },
  { tag: '<AccountType>', example: 'Individual' },
  { tag: '<Adviser>', example: 'Jane Smith' },
  { tag: '<AFSL>', example: '000123456' },
  { tag: '<ClientID>', example: 'CLT78901' },
  { tag: '<ClientName>', example: 'John Doe' },
  { tag: '<IPSPortfolioID>', example: 'IPS123456' },
  { tag: '<PortfolioID>', example: 'PORT456789' },
  { tag: '<PortfolioName>', example: 'Retirement Growth Portfolio' },
  { tag: '<Practice>', example: 'Wealth Advisory Group' },
  { tag: '<ReportPeriodStartDate_MMM-YY>', example: 'Jan-24' },
  { tag: '<ReportPeriodStartDate_YYYY-MM-DD>', example: '2024-01-01' },
  { tag: '<ReportPeriodEndDate_MMM-YY>', example: 'Mar-24' },
  { tag: '<ReportPeriodEndDate_YYYY-MM-DD>', example: '2024-03-31' },
  { tag: '<ReportName>', example: 'PortfolioValuation' },
  { tag: '<GenerationDate_YYYY-MM-DD>', example: '2025-05-23' },
];

export const REPORT_STATUS_NAMES: Record<string, ReportStatus> = {
  '0': 'Not Started',
  P: 'In Progress',
  C: 'Completed',
  E: 'Error',
};

export const SCHEDULED_INSTANCE_STATUS_NAMES: Record<string, ScheduledEventStatus> = {
  P: 'Pending Review',
  A: 'Approved',
  R: 'Rejected',
};

export const SCHEDULED_INSTANCE_STATUS_COLORS: Record<
  string,
  OverridableStringUnion<'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning', ChipPropsColorOverrides>
> = {
  'Pending Review': 'info',
  Approved: 'success',
  Rejected: 'error',
};

export const REPORT_STATUS_COLORS: Record<
  string,
  OverridableStringUnion<'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning', ChipPropsColorOverrides>
> = {
  'Not Started': 'default',
  'In Progress': 'info',
  Completed: 'success',
  Error: 'error',
};

export const SCHEDULE_RECURRENCE_TYPES: Record<string, string> = {
  Day: 'Daily',
  Week: 'Weekly',
  Month: 'Monthly',
  Year: 'Yearly',
};

export const SCHEDULE_DAYS_OF_WEEK: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const EMAIL_TAGS: string[] = [
  'AdviserEmail',
  'AdviserFullName',
  'AdviserPreferredName',
  'AfslAbn',
  'AfslBusinessAddress',
  'AfslName',
  'AfslNo',
  'AfslPhoneNumber',
  'AuthSigPrefName',
  'ClientAccountName',
  'ClientName',
  'ClientPhysicalAddress',
  'ClientPreferredName',
  'ImageLogo',
  'InvestmentServiceName',
  'PracticePhoneNumber',
  'ReportList',
  'SoaDate',
  'TodayDate',
];
